import { useEffect, useState } from 'react';

export default function SessionRestore({ error, onRetry, onSignIn }) {
  const isError = !!error;
  // Show escape hatch after 6 s so slow connections have a chance, but users aren't trapped
  const [showEscape, setShowEscape] = useState(false);

  useEffect(() => {
    if (isError) return;
    const t = setTimeout(() => setShowEscape(true), 6000);
    return () => clearTimeout(t);
  }, [isError]);

  return (
    <main className={`restore-screen ${isError ? 'has-error' : ''}`}>
      <section className="restore-shell" aria-live="polite" aria-busy={!isError}>
        <div className="restore-copy">
          <div className="restore-heading">
            <p className="workspace-kicker">{isError ? 'Session expired' : 'Connecting'}</p>
            <h1>{isError ? 'Sign in again' : 'Connecting account'}</h1>
            <p>
              {isError
                ? 'Deriv could not reconnect with the saved access on this device.'
                : 'Checking saved access and loading commission data.'}
            </p>
          </div>

          <div className="restore-session">
            <div>
              <span>Account</span>
              <strong>Saved access</strong>
            </div>
          </div>

          {isError ? (
            <>
              <p className="restore-error">{error}</p>
              <div className="restore-actions">
                <button className="btn-primary" onClick={onRetry}>
                  Retry session
                </button>
                <button className="btn-secondary" onClick={onSignIn}>
                  Sign in again
                </button>
              </div>
            </>
          ) : (
            <div className="restore-progress">
              <span className="loader-track" />
              <p>Loading commission data</p>
              {showEscape && (
                <button className="restore-escape" onClick={onSignIn}>
                  Taking too long? Sign in again
                </button>
              )}
            </div>
          )}
        </div>

        <div className="restore-preview" aria-hidden="true">
          <div className="restore-preview-top">
            <span />
            <span />
            <span />
          </div>
          <div className="restore-preview-grid">
            <span />
            <span />
            <span />
          </div>
          <div className="restore-chart">
            <i />
            <i />
            <i />
            <i />
            <i />
            <i />
          </div>
        </div>
      </section>
    </main>
  );
}
